import React from "react";

import { Navigate, Route, Routes } from "react-router-dom";

// Layouts
import DoctorLayout from "../components/layouts/DoctorLayout";

// Public Routes

// Doctor Routes
// Doctor Auth
import DoctorInformationScreen from "../containers/doctor-flow/doctor-detail-screen/DoctorDetailScreen";
import ProfileUnderReview from "../containers/doctor-flow/doctor-profile-underview/DoctorProfileUnderReview";

// Doctor Pages
import AppointmentsDetails from "../containers/doctor-flow/appointments-details/AppointmentsDetails";
import DoctorAppointmentsListings from "../containers/doctor-flow/doctor-appointments-listing-page/DoctorAppointmentsListings";
import DoctorDashboard from "../containers/doctor-flow/doctor-dashboard/DoctorDashboard";
import DoctorPatientProfile from "../containers/doctor-flow/doctor-patient-profile/DoctorPatientProfile";
import DoctorPatientslistings from "../containers/doctor-flow/doctor-patients-listing-page/DoctorPatientslisting";
import DoctorPaymentHistoryListings from "../containers/doctor-flow/doctor-payments-listing-page/DoctorPaymentHistoryListing";
import DoctorProfileScreen from "../containers/doctor-flow/doctor-profile/DoctorProfile";
import DoctorSetAvailabilityScreen from "../containers/doctor-flow/doctor-set-availability/DoctorSetAvailability";
import DoctorViewCalendar from "../containers/doctor-flow/doctor-view-calendar/DoctorViewCalendar";
import DoctorViewDoctorProfile from "../containers/doctor-flow/doctor-view-doctor-profile/DoctorViewDoctorProfile";
import DoctorSharedPatientEMRListings from "../containers/doctor-flow/emr-sharing-listing-page/DoctorSharedPatientEMRListings";

// GUARDS
import { useSelector } from "react-redux";
import DoctorVideoCallPanel from "../containers/doctor-flow/doctor-video-call/DoctorVideoCallPanel";
import {
  DoctorProfileCompleteRoute,
  DoctorProtectedRoute,
} from "./doctorRoutesGuard";

const DoctorRoutes = () => {
  const user = useSelector((state) => state.userReducer.user);

  return (
    <Routes>
      <Route path="/doctor" element={<DoctorLayout />}>
        {/* Add explicit route for the base doctor path */}
        <Route index element={<Navigate to="/doctor/dashboard" replace />} />

        {/* PRIVATE DOCTOR ROUTES*/}
        <Route element={<DoctorProtectedRoute />}>
          <Route path="information" element={<DoctorInformationScreen />} />
          <Route path="profileUnderReview" element={<ProfileUnderReview />} />
          {/* PRIVATE DOCTOR ROUTES IF HIS PROFILE IS COMPLETE AND VERIFIED */}
          <Route element={<DoctorProfileCompleteRoute />}>
            <Route path="dashboard" element={<DoctorDashboard />} />
            <Route path="profileUnderReview" element={<ProfileUnderReview />} />
            <Route path="patients" element={<DoctorPatientslistings />} />
            <Route
              path="appointments"
              element={<DoctorAppointmentsListings />}
            />
            <Route path="payments" element={<DoctorPaymentHistoryListings />} />
            <Route
              path="emr-sharing"
              element={<DoctorSharedPatientEMRListings />}
            />
            <Route
              path="set-availability"
              element={<DoctorSetAvailabilityScreen />}
            />
            <Route path="profile" element={<DoctorProfileScreen />} />
            <Route path="view-calendar" element={<DoctorViewCalendar />} />
            <Route
              path="appointments-details"
              element={<AppointmentsDetails />}
            />
            <Route path="patient-profile" element={<DoctorPatientProfile />} />
            <Route
              path="doctor-consultation-panel"
              element={<DoctorVideoCallPanel />}
            />
            <Route
              path="view-doctor-profile"
              element={<DoctorViewDoctorProfile />}
            />
          </Route>
        </Route>
      </Route>
      {/* REDIRECT TO EITHER DASHBOARD OR PROFILE COMPLETE SCREEN IF ANY UNKNOWN ROUTE APPEARS */}
      {user.userType === "doctor" && !user.isProfileComplete ? (
        <Route
          path="*"
          element={<Navigate to="/doctor/information" replace />}
        />
      ) : user.userType === "doctor" && !user.isProfileVerfied ? (
        <Route
          path="*"
          element={<Navigate to="/doctor/profileUnderReview" replace />}
        />
      ) : (
        <Route path="*" element={<Navigate to="/doctor/dashboard" replace />} />
      )}
    </Routes>
  );
};

export default DoctorRoutes;
